import React from "react"
import "./style.scss"
import Button from "../../elements/button/Button"
import Form from "react-bootstrap/Form"
import PhoneInput from "../../elements/phoneInput/Input"
import Spinner from "react-bootstrap/Spinner"
import { validateEmail } from "../../../utils"

const Contact = ({
  contactDescription,
  contactTitle,
  btnBg,
  btnColor,
  className,
  handleNumberSelect,
  getCountryCode,
  details,
  onChange,
  onCheck,
  submit,
  fontSize,
}) => {
  return (
    <div className={`inquire ${className ? className : ""}`}>
      <h1 className="title-header" style={{ fontSize: fontSize && fontSize }}>
        {contactTitle || "Let’s connect to know more"}
      </h1>
      <p className="description">{contactDescription}</p>
      <div className="contact-form">
        <div className="contact-item">
          <div className="two-col-area">
            <FormItem
              name="name"
              value={details.name}
              onChange={onChange}
              type="text"
              label="NAME"
              error={
                details.submitted &&
                details.name === "" &&
                "Name cannot be empty"
              }
            />
            <FormItem
              name="email"
              value={details.email}
              onChange={onChange}
              type="email"
              label="EMAIL"
              className="mr-0"
              error={
                (details.submitted &&
                  details.email === "" &&
                  "Email cannot be empty") ||
                (details.submitted &&
                  !validateEmail(details.email) &&
                  "Email not valid")
              }
            />
          </div>
          <div className="two-col-area">
            <FormItem
              label="PHONE"
              onChange={handleNumberSelect}
              getCountryCode={getCountryCode}
              value={details && details.phone}
              phone
              error={
                details.submitted &&
                details.phone === "" &&
                "Phone cannot be empty"
              }
              className="phoneField"
            />
            <FormItem
              name="company"
              value={details.company}
              onChange={onChange}
              type="text"
              label="COMPANY NAME"
              className="mr-0"
              error={
                details.submitted &&
                details.company === "" &&
                "Company cannot be empty"
              }
            />
          </div>
          <FormItem
            value={details.designation}
            onChange={onChange}
            name="designation"
            type="text"
            label="DESIGNATION"
            style={{ width: "auto" }}
            error={
              details.submitted &&
              details.designation === "" &&
              "Designation cannot be empty"
            }
          />
          <FormItem
            value={details.comments}
            onChange={onChange}
            label="COMMENTS"
            name="comments"
            type="text"
            rows="4"
            textarea
            error={
              details.submitted &&
              details.comments === "" &&
              "Comments cannot be empty"
            }
          />

          <Form.Check className="mt-5">
            <Form.Check.Input
              onChange={onCheck}
              name="terms"
              checked={details.terms}
              type="checkbox"
              isValid
            />
            <Form.Check.Label>
              By checking this you accept our{" "}
              <a href="/privacy-policy">privacy policy</a>
            </Form.Check.Label>
          </Form.Check>
          <Button
            onClick={submit}
            style={{
              background: btnBg ? btnBg : "",
              color: btnColor ? btnColor : "",
            }}
            className="mt-3 submitBtn"
          >
            Submit &nbsp;
            {details.requesting && <Spinner animation="border" size="sm" />}
          </Button>
        </div>
        <div className="image-container">
          <img alt="representative" />
        </div>
      </div>
    </div>
  )
}

export default Contact
const FormItem = ({
  className,
  label,
  onChange,
  textarea,
  phone,
  getCountryCode,
  error,
  ...props
}) => {
  return (
    <div
      className={`form-item ${className ? className : ""} ${
        error ? "has-error" : ""
      }`}
    >
      <label>{label}</label>
      {!textarea && !phone && (
        <input
          value={props.value}
          onChange={onChange}
          name={props.name}
          type={props.type}
          style={props.style}
        />
      )}
      {textarea && !phone && (
        <textarea
          value={props.value}
          onChange={onChange}
          name={props.name}
          type={props.type}
          rows={props.rows}
        />
      )}
      {phone && (
        <PhoneInput
          onChange={onChange}
          getCountryCode={getCountryCode}
          value={props.value}
        />
      )}
      {error && <p className={"error-message"}>{error}</p>}
    </div>
  )
}
